const programDescriptions = {
  'Backpack Buddy': 'Nutritious, kid-friendly food is provided for the weekend for at-risk children in schools grade K-12 and summer meal program sites.',
  'Kids Cafe': 'Nourishing kid friendly meals served year-round to children in child care, after-school and summer meal program sites throughout 18 southeast Texas counties.',
  'Partner Services': 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua lorem ipsum dolor sit amet.',
  'School Market': 'Alleviating child and teen hunger by providing food to students and their families at middle and high schools.',
  'Teachers Aid': 'Providing school supplies for teachers in low income schools.',
};

export default programDescriptions;
